import { memo, useRef, useEffect, useState, useCallback } from 'react';
// import { CKEditor } from '@ckeditor/ckeditor5-react';
// import {
//   ClassicEditor,
//   Essentials,
//   Bold,
//   Italic,
//   Underline,
//   Strikethrough,
//   Alignment,
//   FontSize,
//   FontColor,
//   Highlight,
//   Indent,
//   IndentBlock,
//   Heading,
//   List,
//   Table,
//   TableToolbar,
//   Undo,
// } from 'ckeditor5';
// import 'ckeditor5/ckeditor5.css';
// import 'katex/dist/katex.min.css';
// import '../../../ckeditor/math-formula.css';

// import MathPlugin from '../../../ckeditor/plugins/math/MathPlugin';
// import MathFormulaModal from './MathFormulaModal';
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

// const EDITOR_PLUGINS = [
//   Essentials,
//   Bold,
//   Italic,
//   Underline,
//   Strikethrough,
//   Alignment,
//   FontSize,
//   FontColor,
//   Highlight,
//   Indent,
//   IndentBlock,
//   Heading,
//   List,
//   Table,
//   TableToolbar,
//   Undo,
//   // MathPlugin,
// ];

// const EDITOR_TOOLBAR = {
//   items: [
//     'heading',
//     '|',
//     'bold',
//     'italic',
//     'underline',
//     'strikethrough',
//     '|',
//     'alignment',
//     '|',
//     'fontSize',
//     'fontColor',
//     'highlight',
//     '|',
//     'bulletedList',
//     'numberedList',
//     '|',
//     'outdent',
//     'indent',
//     '|',
//     'insertTable',
//     '|',
//     // 'mathFormula',
//     '|',
//     'undo',
//     'redo',
//   ],
// };

// const TABLE_CONFIG = {
//   contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells'],
// };

function getBestAnswerData(selectedValue, selectedValueSrNo, currentSrNo) {
  if (typeof selectedValue === "string" && String(selectedValueSrNo) === String(currentSrNo)) {
    return selectedValue;
  }
  return sessionStorage.getItem(`descriptive_answer_${currentSrNo}`) || "";
}

const DescriptiveTypingAnswer = memo(
  ({ selectedValue, selectedValueSrNo, handleTypingChange, editorInstanceRef, currentSrNo }) => {
    const editorRef = useRef(null);
    // Prevents onChange from firing when setData() is called programmatically
    const isProgrammaticRef = useRef(false);
    const [modalState, setModalState] = useState({
      open: false,
      initialLatex: '',
      onConfirm: null,
    });

    // Passed into editor config so MathUI plugin can open the React modal
    // const openMathModal = useCallback((initialLatex, onConfirm) => {
    //   setModalState({ open: true, initialLatex, onConfirm });
    // }, []);

    // const closeMathModal = useCallback(() => {
    //   setModalState((prev) => ({ ...prev, open: false }));
    // }, []);

    // const handleModalConfirm = useCallback(
    //   (latex) => {
    //     modalState.onConfirm?.(latex);
    //   },
    //   [modalState]
    // );

    // Lets onReady read the latest values even if CKEditor re-invokes onReady
    // with a stale closure (e.g. React StrictMode's double-invoke in dev).
    const selectedValueRef = useRef(selectedValue);
    selectedValueRef.current = selectedValue;
    const selectedValueSrNoRef = useRef(selectedValueSrNo);
    selectedValueSrNoRef.current = selectedValueSrNo;

    useEffect(() => {
      if (!editorRef.current) return;
      const editableEl = editorRef.current.ui?.view?.editable?.element;
      const isFocused = editableEl && editableEl.contains(document.activeElement);
      if (isFocused) return;
      const currentData = editorRef.current.getData();
      const finalData = getBestAnswerData(selectedValue, selectedValueSrNo, currentSrNo);

      if (currentData !== finalData) {
        isProgrammaticRef.current = true;
        editorRef.current.setData(finalData);
      }
    }, [selectedValue, selectedValueSrNo, currentSrNo]);

    return (
      <div style={{ minHeight: '140px' }}>
        <CKEditor
          editor={ClassicEditor}
          config={{
            licenseKey: 'GPL',
            // plugins: EDITOR_PLUGINS,
            // toolbar: EDITOR_TOOLBAR,
            // table: TABLE_CONFIG,

            toolbar: [
              'heading',
              '|',
              'bold',
              'italic',
              'underline',
              'strikethrough',
              '|',
              'bulletedList',
              'numberedList',
              '|',
              'insertTable',
              '|',
              'undo',
              'redo',
            ],

            // math: {
            //   openModal: openMathModal,
            // },
          }}
          onError={(error, details) => {
            console.error('CKEditor error:', error, details);
          }}
          onReady={(editor) => {
            editorRef.current = editor;
            editorInstanceRef.current = editor;
            isProgrammaticRef.current = true;
            editor.setData(getBestAnswerData(selectedValueRef.current, selectedValueSrNoRef.current, currentSrNo));
          }}
          onChange={(_event, editor) => {
            if (isProgrammaticRef.current) {
              isProgrammaticRef.current = false;
              return;
            }
            handleTypingChange(editor.getData());
          }}
        />
        {/* <MathFormulaModal
          open={modalState.open}
          initialLatex={modalState.initialLatex}
          onConfirm={handleModalConfirm}
          onClose={closeMathModal}
        /> */}
      </div>
    );
  }
);

export default DescriptiveTypingAnswer;
